<template>
  <loading-logo v-if="isFetching" />
  <main v-else>
    <drm-restore-apparece />
    <section>

      <div>
        <h4 class="body-bold-base neutral-20-dark--text">
          {{ $t('message.pages.drm.drmApparence.title') }}
        </h4>
        <h5 class="body-regular-smaller neutral-40-light--text">
          {{ $t('message.pages.drm.drmApparence.description') }}
        </h5>
      </div>
      <div class="d-flex justify-space-between align-center my-4">
        <span class="body-regular-small neutral-20-dark--text">{{
          $t('message.pages.drm.drmApparence.size')
        }}</span>
        <div style="width: 50%">
          <v-select v-model="group.fontSize" :items="fontSizeItems" item-text="label" item-value="value" outlined
            :menu-props="{ top: false, offsetY: true }" dense hide-details @change="changePreview" />
        </div>
      </div>
      <v-row class="mt-2">
        <v-col cols="6" class="d-flex align-center">
          <div class="d-flex flex-column">
            <span class="body-regular-small feat-title">{{
              $t('message.pages.drm.drmApparence.colorText')
            }}</span>
          </div>
        </v-col>
        <v-col cols="6" class="d-flex justify-end">
          <v-menu offset-x v-model="menuFontColor" top nudge-bottom="105" nudge-left="16"
            :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-btn class="ml-2 rounded-pill border-slate" :color="group.fontColor" v-on="on" :style="setFontColor"
                icon><span class="describeHexa">{{ group.fontColor.slice(0, -2) }}</span></v-btn>
            </template>
            <v-color-picker elevation="3" @input="changePreview" @keydown="changePreview" v-model="group.fontColor" flat
              mode="hexa" hide-mode-switch :maxlength="7"></v-color-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col cols="6" class="d-flex align-center">
          <div class="d-flex flex-column">
            <span class="body-regular-small feat-title">{{
              $t('message.pages.drm.drmApparence.colorBackground')
            }}</span>
          </div>
        </v-col>
        <v-col cols="6" class="d-flex justify-end">
          <v-menu offset-x v-model="menuBoxColor" bottom nudge-bottom="105" nudge-left="16"
            :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-btn class="ml-2 rounded-pill border-slate" :color="group.boxColor" v-on="on" :style="setMenuBoxColor"
                icon><span class="describeHexa">{{ group.boxColor.slice(0, -2) }}</span></v-btn>
            </template>
            <v-color-picker @input="changePreview" @keydown="changePreview" elevation="3" v-model="group.boxColor" flat
              mode="hexa" hide-mode-switch :maxlength="7"></v-color-picker>
          </v-menu>
        </v-col>
      </v-row>
      <div class="d-flex justify-space-between align-center my-4">
        <span class="body-regular-small neutral-20-dark--text">{{
          $t('message.pages.drm.drmApparence.restore')
        }}</span>
        <div style="width: 50%; display: flex; justify-content: flex-end;">
          <v-tooltip bottom :disabled="isChangeApparece">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <base-btn :disabled="!isChangeApparece" type="tertiary" @click="openModalRestore">
                  {{ $t('message.playerPage.restoreSettingsModal.action') }}
                </base-btn>
              </div>
            </template>
            <span>{{ $t('message.pages.drm.drmApparence.restoreTooltip') }}</span>
          </v-tooltip>
        </div>
      </div>

    </section>
  </main>
</template>
<script>
import drmApi from '@/services/drmApi'
import { mapMutations } from 'vuex'
import _ from 'lodash'
import LoadingLogo from '../../../components/LoadingLogo.vue'
import i18n from '@/translations/lang'
import BaseBtn from '../../../components/BaseBtn.vue'
import DrmRestoreApparece from './DrmRestoreApparece.vue'
export default {
  name: 'DrmSettingsStyle',
  components: { LoadingLogo, BaseBtn, DrmRestoreApparece },
  props: {
    selectedDrmGroup: Object,
    handleCloseModal: Function,
  },
  data: () => ({
    isFetching: false,
    groupId: '',
    group: {
      fontFamily: 'rubik',
      fontColor: '#FFFFFF',
      fontSize: 12,
      boxColor: '#7999CE',
      boxOpacity: 1,
    },
    fontFamilyItems: [
      { text: 'Arial', value: 'arial' },
      { text: 'Fredoka Regular', value: 'fredoka-regular' },
      { text: 'Helvetica', value: 'helvetica' },
      { text: 'Times New Roman', value: 'times-new-roman' },
    ],
    fontSizeItems: [
      {
        label: i18n.t('message.pages.drm.drmApparence.sizes.small'),
        value: 8,
      },
      {
        label: i18n.t('message.pages.drm.drmApparence.sizes.medium'),
        value: 12,
      },
      {
        label: i18n.t('message.pages.drm.drmApparence.sizes.large'),
        value: 16,
      },
      {
        label: i18n.t('message.pages.drm.drmApparence.sizes.xlarge'),
        value: 20,
      },
    ],

    menuFontColor: false,
    menuBoxColor: false,
    initialObject: {},
  }),
  computed: {
    hasEditDrmPerm() {
      return (
        this.$store.state.user.userPermissions?.includes('put-watermark') ??
        false
      )
    },
    isChangeApparece() {
      const isTrue = this.group.fontColor !== '#FFFFFFFF' || this.group.boxColor !== '#00000066' || this.group.fontSize !== 12
      return isTrue
    },
    setFontColor() {
      return {
        backgroundColor: this.group.fontColor,
        borderRadius: '4px',
        transition: 'border-radius 200ms ease-in-out',
      }
    },
    setMenuBoxColor() {
      return {
        backgroundColor: this.group.boxColor,
        borderRadius: '4px',
        transition: 'border-radius 200ms ease-in-out',
      }
    },
  },
  watch: {
    selectedDrmGroup: {
      immediate: true,
      handler(val) {
        this.groupId = val.id
        this.group.fontFamily = val.config['font-family'] || 'fredoka-regular'
        this.group.fontColor = val.config['font-color'] || '#FFFFFFFF'
        this.group.fontSize = Number(val.config['font-size']) || 18
        this.group.boxColor = val.config['box-color'] || '#7999CEFF'
        this.group.boxOpacity = val.config['box-opacity'] || 1
        if (this.group.fontColor.length < 8) {
          this.group.fontColor += 'FF'
        }
        if (this.group.boxColor.length < 8) {
          this.group.boxColor += 'FF'
        }
        this.initialObject = {
          percent_ts: this.group.percentTs,
          'font-family': this.group.fontFamily.toString(),
          'font-color': this.group.fontColor.toString(),
          'font-size': this.group.fontSize.toString(),
          'box-color': this.group.boxColor.toString(),
        }
      },
    },
  },
  methods: {
    ...mapMutations('user', [
      'UPDATE_GLOBAL_SNACKBAR',
      'UPDATE_SHOULD_FETCH_ALL_VIDEOS',
    ]),
    changePreview() {
      let boxOpacityVal = this.getOpacityFromHexColor(
        this.group.boxColor.toString()
      )
      let groupObject = {
        percent_ts: this.group.percentTs,
        'font-family': 'Rubik',
        'font-color': this.group.fontColor.toString(),
        'font-size': this.group.fontSize.toString(),
        'box-color': this.group.boxColor.toString(),
        'box-opacity': boxOpacityVal.toString(),
      }
      this.selectedDrmGroup.config = {
        ...this.selectedDrmGroup.config,
        ...groupObject,
      }
      this.$root.$emit('changePreview', this.selectedDrmGroup)
    },
    getOpacityFromHexColor(hexColor) {
      const color = hexColor.startsWith('#') ? hexColor.slice(1) : hexColor
      const colorRegex = /^([0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/
      if (!colorRegex.test(color)) {
        return 1.0
      }
      const opacityHex = color.slice(-2)
      const opacityDecimal = parseInt(opacityHex, 16) / 255
      const opacity = Math.round(opacityDecimal * 100) / 100
      return opacity
    },
    handleConfirm() {
      let boxOpacityVal = this.getOpacityFromHexColor(
        this.group.boxColor.toString()
      )
      let groupObject = {
        percent_ts: this.group.percentTs,
        'font-family': 'Rubik',
        'font-color': this.group.fontColor.toString(),
        'font-size': this.group.fontSize.toString(),
        'box-color': this.group.boxColor.toString(),
        'box-opacity': boxOpacityVal.toString(),
      }
      this.handleEdit(groupObject)
    },
    async handleEdit(groupObject) {
      this.isFetching = true
      this.$root.$emit('isBtnloading', true)
      try {
        let ret = await drmApi.drmUpdateVideos(this.groupId, groupObject)
        this.isFetching = false
        this.$root.$emit('updateDrmGroup', ret.data)
        this.$root.$emit('updateDrmGroupStart', ret.data)
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          type: 'success',
          text: this.$t('message.pages.drm.drmApparence.tooltip'),
        })
        this.$root.$emit('isBtnloading', false)
      } catch (e) {
        this.isFetching = false
        this.$root.$emit('isBtnloading', false)
        console.log('e', e)
      }
    },
    openModalRestore() {
      this.$root.$emit('drmRestoreApparece', { groupId: this.groupId })
    },
    async handleClose() {
      if (this.checkChange()) {
        this.$root.$emit(
          'unsavedChangesModal',
          false,
          false,
          false,
          false,
          true
        )
      } else {
        this.handleCloseModal()
      }
    },
    checkChange() {
      return !(
        _.isEqual(
          this.group.fontFamily.toString(),
          this.initialObject['font-family']
        ) &&
        _.isEqual(
          this.group.fontColor.toString(),
          this.initialObject['font-color']
        ) &&
        _.isEqual(
          this.group.fontSize.toString(),
          this.initialObject['font-size']
        ) &&
        _.isEqual(
          this.group.boxColor.toString(),
          this.initialObject['box-color']
        ) &&
        _.isEqual(this.group.percentTs, this.initialObject['percent_ts'])
      )
    },
    resetData() {
      this.group.fontFamily = this.initialObject['font-family']
      this.group.fontColor = this.initialObject['font-color']
      this.group.fontSize = this.initialObject['font-size']
      this.group.boxColor = this.initialObject['box-color']
    },
  },
  mounted() {
    this.$root.$on('publish-apparence-tab', () => {
      this.handleConfirm(this.selectedDrmGroup)
    })
  },
  beforeDestroy() {
    this.$root.$off('publish-apparence-tab')
    this.$root.$off('drmRestoreApparece')
  },
}
</script>
<style lang="scss" scoped>
.border-slate {
  height: 16px !important;
  width: 17px !important;
  border: varFigma(neutral-30-base) 1px solid;
}

.describeHexa {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 10%;
  color: varFigma(neutral-40-light);
  margin-right: 130px;
  width: 100px;
  display: flex;
  justify-content: end;
}

.page__colors {

  &--back,
  &--back-icon {
    color: varFigma(brand-60-base);
  }

  &--title,
  &--player-text {
    color: varFigma(neutral-20-dark);
  }

  &--article,
  &--article-icon {
    color: varFigma(neutral-30-base);
  }

  &--subtext,
  &--desc-feature {
    color: varFigma(neutral-40-light);
  }
}
</style>
